// src/components/atoms/Iframe.js

import React from "react";
import PropTypes from "prop-types";

const Iframe = ({ src, title, ...props }) => (
  <iframe src={src} title={title} {...props} />
);

Iframe.propTypes = {
  src: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
};

export default Iframe;
